import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemeService } from '../../services/theme.service';
import { ITheme } from 'src/app/models/ITheme';
import { Observable, Subscription } from 'rxjs';
import { ItemService } from '../../services/item.service';
import { IItem } from '../../models/IItem';

@Component({
  selector: 'theme-form',
  templateUrl: './theme-form.component.html',
  styleUrls: ['./theme-form.component.scss']
})
export class ThemeFormComponent implements OnInit, OnDestroy {
  form: FormGroup;
  uploaded;
  id;
  allItems: IItem[];
  filteredItems: IItem[];
  weight = 1;
  itemsSubscription: Subscription;
  error;

  constructor(private fb: FormBuilder, private themeService: ThemeService, private itemService: ItemService) { }

  ngOnInit(): void {
    this.itemsSubscription = this.itemService.getAll().subscribe(res => {
      this.allItems = res;
      this.filteredItems = res;
    });
    this.uploaded = false;
    this.id = null;
    this.buildForm(null);
  }

  buildForm(theme: ITheme) {
    if (theme) { this.id = theme.id; }
    this.form = this.fb.group({
      name: [theme ? theme.name : '', Validators.required],
      image: [theme ? theme.image : '', Validators.required],
      region: [theme ? theme.region : '', Validators.required],
      weight: [theme ? theme.weight : this.weight, Validators.required],
      items: this.fb.array(theme ? theme.items : [])
    });
  }

  toggleItem(value) {
    const array: FormArray = (this.form.get('items') as FormArray);
    if (array.value.includes(value)) {
      (this.form.get('items') as FormArray).removeAt(array.value.findIndex(v => v === value));
    }
    else { array.push(new FormControl(value, Validators.required)); }
  }

  itemAdded(id: string) {
    return this.form.get('items').value.includes(id);
  }

  submitForm() {
    this.themeService.set(this.form.getRawValue(), this.id).finally(() => this.ngOnInit());
  }

  setItemsType(value: string) {
    if (value.length > 0) {
      this.filteredItems = this.allItems.filter(i => i.type.toLowerCase().includes(value.toLowerCase()));
    } else {
      this.filteredItems = this.allItems;
    }
  }

  filterItems(value: string) {
    if (value.length > 0) {
      this.filteredItems = this.filteredItems.filter(i => i.name.toLowerCase().includes(value.toLowerCase()));
    } else {
      this.filteredItems = this.allItems;
    }
  }

  uploadImage(files: FileList) {
    if (!this.uploaded && files.length > 0) {
      if (files[0].type === 'image/jpg' || files[0].type === 'image/png' || files[0].type === 'image/jpeg') {
        this.themeService.uploadImage(files[0]).then(url => {
          this.form.patchValue({ image: url });
          this.uploaded = true;
        });
      } else {
        this.error = 'Unsupported image type. Supported only JPG and PNG';
      }
    }
  }

  ngOnDestroy() {
    this.itemsSubscription.unsubscribe();
  }

}
